// extracted by mini-css-extract-plugin
module.exports = {"fons":"videojocs_fons__jBkSB"};